// This file was auto-generated by Fern from our API Definition.
export var GatewayToolConfig;
(function (GatewayToolConfig) {
    GatewayToolConfig.Permission = {
        Allow: "allow",
        Ask: "ask",
        Deny: "deny",
    };
})(GatewayToolConfig || (GatewayToolConfig = {}));
